import request, {Method} from '@/plugins/request.js'
import {postRequestWithNoToken} from '../plugins/request';

// 获取首页楼层装修数据
export function indexData (params) {
  return request({
    url: '/buyer/pageData/getIndex',
    method: Method.GET,
    needToken: false,
    params
  })
}

/**
 * 楼层装修数据
 * @param pageClientType 客户端类型,可用值:PC,H5,WECHAT_MP,APP
 * @param pageType 页面类型,可用值:INDEX,STORE,SPECIAL
 */
export function pageData (params) {
  return request({
    url: `/buyer/pageData`,
    method: Method.GET,
    needToken: false,
    params
  })
}
/**
 * 刷新token
 */
export function handleRefreshToken (token) {
  return request({
    url: `/buyer/members/refresh/${token}`,
    method: Method.GET,
    needToken: false
  })
}

export function savePersonInfo(params){
  return request({
    url: `/api/ct-consumer/common/personnelInformation/save`,
    method: Method.POST,
    needToken: false,
    data: params,
    headers: {'Content-Type': 'application/json'},
  })
  // return postRequestWithNoToken("http://localhost:10002/api/ct-consumer/common/personnelInformation/save",params)
}



// WEBPACK FOOTER //
// ./src/api/index.js